// src/version.js
// Sistema de versionamiento de la aplicación

export const APP_VERSION = {
  // Versión semántica: MAJOR.MINOR.PATCH
  version: '1.2.5',

  // Fecha de la última actualización (formato YYYY-MM-DD)
  buildDate: '2025-12-17',

  // Nombre de la versión (opcional, para releases importantes)
  codename: 'Retoma',

  // Entorno
  environment: process.env.NODE_ENV || 'development',

  // Método para obtener la versión completa como string
  getFullVersion() {
    return `v${this.version}`;
  },

  // Método para obtener información completa
  getVersionInfo() {
    return {
      version: this.version,
      buildDate: this.buildDate,
      codename: this.codename,
      environment: this.environment,
      fullVersion: this.getFullVersion()
    };
  },

  // Método para mostrar en consola
  logVersion() {
    console.log(`
╔═══════════════════════════════════════╗
║     🔄 Retoma - Sistema de Retomas   ║
║                                       ║
║  Versión: ${this.getFullVersion().padEnd(27)} ║
║  Build: ${this.buildDate.padEnd(29)} ║
║  Entorno: ${this.environment.padEnd(27)} ║
╚═══════════════════════════════════════╝
    `);
  }
};

// Mostrar versión en consola al cargar la aplicación
if (typeof window !== 'undefined') {
  APP_VERSION.logVersion();

  // Hacer disponible globalmente para debugging
  window.APP_VERSION = APP_VERSION;
}

export default APP_VERSION;
